module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center",
    staticStyle: {
      "max-width": "380px",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_vm._l((_vm.actions), function(action) {
    return _c('v-btn', _vm._g(_vm._b({
      key: action.id,
      staticClass: "mb-4",
      staticStyle: {
        "border-radius": "25px"
      },
      attrs: {
        "block": "",
        "rounded": "",
        "x-large": "",
        "outline": "",
        "color": "primary"
      },
      on: {
        "click": action.click
      }
    }, 'v-btn', action.attrs, false), action.events), [_vm._v("\n      " + _vm._s(action.text) + "\n      "), (action.icon) ? _c('v-icon', {
      staticClass: "ml-2",
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(action.icon))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.withDone) ? _c('v-btn', {
    staticClass: "my-4",
    attrs: {
      "block": "",
      "rounded": "",
      "x-large": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n      Done\n    ")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf21af9e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wizards/screens/SuccessScreen.vue
// module id = 1517
// module chunks = 9